var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"stamp"},[_c('div',{staticClass:"stamp_circ"},[_c('div',{staticClass:"circ blink1"}),_c('div',{staticClass:"circ blink2"}),_c('div',{staticClass:"circ blink3"})]),_c('div',{staticClass:"stamp_text"},[_c('h4',[_vm._v("author: Гречишников Олег")]),_c('h4',[_vm._v("Test task on Vue2")])])])
}]

export { render, staticRenderFns }